import { alpha, styled, Typography } from '@mui/material';

interface StyledTopicTagProps {
  color: string;
  density: 'panel' | 'page';
}

const StyledTopicTag = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'color' && prop !== 'density',
})<StyledTopicTagProps>(({ color, density }) => ({
  display: 'inline-flex',
  overflow: 'hidden',
  padding: density === 'panel' ? '3px 8px' : '4px 10px',
  borderRadius: 4,
  textTransform: 'uppercase',
  fontWeight: 700,
  fontSize: density === 'panel' ? 12 : 13,
  lineHeight: density === 'panel' ? '16px' : '18px',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  color,
  backgroundColor: alpha(color, 0.1),
}));

export default StyledTopicTag;
